import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ApiAttributesGroupsService } from 'src/app/services';
import { ApiAttributesService } from 'src/app/services/api-attributes.service';


@Component({
  selector: 'app-attribute-deletion-confirmation',
  templateUrl: './attribute-deletion-confirmation.component.html',
  styleUrls: ['./attribute-deletion-confirmation.component.css']
})
export class AttributeDeletionConfirmationComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();

  selectedAtributIds: any;
  selectedAtributGroupId: any;
  productInfo: any;
  productInfoError: any;

  // данные атрибутов
  @Input() set data(value) {

    if (value != null) {

     this.selectedAtributIds = value.ids;
    }
  }

  constructor(
    public ngProgress: NgProgress,
    private apiAttributesService: ApiAttributesService,
    public activeModal: NgbActiveModal,
    private apiService: ApiAttributesGroupsService,
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    if(this.selectedAtributIds) {

      this.attrInfo();
    }
    

    if(this.selectedAtributGroupId) {

      this.attrGroupInfo();
    }
  
    
    console.log(this.selectedAtributGroupId);
  }


  /**
   * 
   */
  attrInfo() {

    let data = {
      attr_id: this.selectedAtributIds,
      mandatory: false
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttributesService.deleteAttribute(data).subscribe(response => { console.log('[RESPONSE] attrInfo: ', response);

        if (response != null) {

          this.productInfoError = response;
          this.productInfo = response.result;
          console.log(this.productInfo);
          
          
          // this.getList();
          // this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  attrGroupInfo() {

    let data = {
      id: this.selectedAtributGroupId,
      mandatory: false
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiService.delete(data).subscribe(response => { console.log('[RESPONSE] attrInfo: ', response);

        if (response != null) {

          // this.productInfoError = response;
          // this.productInfo = response.result;
          console.log(this.productInfo);
          
          
          // this.getList();
          // this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  delete() {

    let data = {
      attr_id: this.selectedAtributIds,
      mandatory: true
    }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiAttributesService.deleteAttribute(data).subscribe(response => { console.log('[RESPONSE] attrInfo: ', response);

        if (response != null) {
          
          this.activeModal.close(true);
        }

        this.progressRef.complete();
      })
    );
  }


  /**
   * 
   */
  close() {
    
    this.activeModal.close(false);
  }

}
